import React, { ReactElement } from 'react'
import StatisticsRowItem from '../RowItem/StatisticsRowItem'
import RowFont from '../RowFont'

type Props = {
    percent?: number | string
    width: number
}

const Percent = ({ percent, width }: Props): ReactElement => {
    return (
        <StatisticsRowItem width={width}>
            <RowFont bold>{percent || ''}</RowFont>
        </StatisticsRowItem>
    )
}

export default Percent
